import { createSelector } from "reselect";
import { getFormValues } from "redux-form";

const reductionUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.reduction_factor) {
    return formValue.detail.reduction_factor;
  } else {
    return [];
  }
};

const enhancementUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.enhancement_factor) {
    return formValue.detail.enhancement_factor;
  } else {
    return [];
  }
};

const additionUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.addition_factor) {
    return formValue.detail.addition_factor;
  } else {
    return [];
  }
};

export const mandDayUpdateSelector = createSelector(
  reductionUpdate,
  enhancementUpdate,
  additionUpdate,
  (reduction, enhancement, addition) => {
    const allReduction = reduction.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const allEnhancement = enhancement.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const allAddition = addition.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const baseValue = allEnhancement + allAddition - allReduction;

    if (baseValue > 30) {
      return 30;
    } else if (baseValue < -30) {
      return -30;
    } else {
      return baseValue;
    }
  }
);

const phases = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.audit_cycle) {
    return formValue.detail.audit_cycle;
  } else {
    return [];
  }
};

const additionals = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.additional_service) {
    return formValue.detail.additional_service;
  } else {
    return [];
  }
};

const fees = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.fees) {
    return formValue.detail.fees;
  } else {
    return [];
  }
};

export const totalFeesUpdateSelector = createSelector(
  phases,
  additionals,
  fees,
  (phases, additionals, fees) => {
    const allPhase = phases.reduce((x, y) => {
      return x + y.day * y.rate;
    }, 0);

    const allAdditional = additionals.reduce((x, y) => {
      return x + y.day * y.rate;
    }, 0);

    const allFees = fees.reduce((x, y) => {
      return x + y.quantity * y.rate;
    }, 0);

    return allPhase + allAdditional + allFees;
  }
);

const reductionCreate = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.reduction_factor) {
    return formValue.detail.reduction_factor;
  } else {
    return [];
  }
};

const enhancementCreate = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.enhancement_factor) {
    return formValue.detail.enhancement_factor;
  } else {
    return [];
  }
};

const additionCreate = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.addition_factor) {
    return formValue.detail.addition_factor;
  } else {
    return [];
  }
};

export const mandDayCreateSelector = createSelector(
  reductionCreate,
  enhancementCreate,
  additionCreate,
  (reduction, enhancement, addition) => {
    const allReduction = reduction.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const allEnhancement = enhancement.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const allAddition = addition.reduce((x, y) => {
      return x + y.value;
    }, 0);

    const baseValue = allEnhancement + allAddition - allReduction;

    if (baseValue > 30) {
      return 30;
    } else if (baseValue < -30) {
      return -30;
    } else {
      return baseValue;
    }
  }
);

const createPhases = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.audit_cycle) {
    return formValue.detail.audit_cycle;
  } else {
    return [];
  }
};

const createAdditionals = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.additional_service) {
    return formValue.detail.additional_service;
  } else {
    return [];
  }
};

const createFees = (state) => {
  const formValue = getFormValues("quotationCreateForm")(state);
  if (formValue && formValue.detail && formValue.detail.fees) {
    return formValue.detail.fees;
  } else {
    return [];
  }
};

const createPhasesUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.audit_cycle) {
    return formValue.detail.audit_cycle;
  } else {
    return [];
  }
};

const createAdditionalsUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.additional_service) {
    return formValue.detail.additional_service;
  } else {
    return [];
  }
};

const createFeesUpdate = (state) => {
  const formValue = getFormValues("quotationUpdateForm")(state);
  if (formValue && formValue.detail && formValue.detail.fees) {
    return formValue.detail.fees;
  } else {
    return [];
  }
};

export const totalFirstYearFeesCreateSelector = createSelector(
  createPhases,
  createAdditionals,
  createFees,
  (phases, additionals, fees) => {
    const allPhase = phases.reduce((sum, x) => {
      if (x.phase.indexOf("Surveillance") < 0) {
        return sum + x.day * x.rate;
      }
      return sum;
    }, 0);

    const allAdditional = additionals.reduce((x, y) => {
      return x + y.day * y.rate;
    }, 0);

    const allFees = fees.reduce((x, y) => {
      return x + y.quantity * y.rate;
    }, 0);
    return allPhase + allAdditional + allFees;
  }
);

export const getFeesByYear = createSelector(
  createPhases,
  createAdditionals,
  createFees,
  (phases, additionals, fees) => {
    const y1 = phases.reduce((sum, x) => {
      if (x.phase.indexOf("Surveillance") < 0) {
        return sum + x.day * x.rate;
      }
      return sum;
    }, 0);

    const nextYears = phases.reduce((sum, x) => {
      if (x.phase.indexOf("Surveillance") === 0) {
        return [
          ...sum,
          {
            ...x,
            amount: x.day * x.rate,
          },
        ];
      }
      return sum;
    }, []);

    const allFees = fees.reduce((x, y) => {
      return x + y.quantity * y.rate;
    }, 0);

    const result = [
      {
        phase: "First Year",
        description: "CA1 + CA2 + Other fees",
        amount: y1 + allFees,
      },
      ...nextYears,
    ];

    return result;
  }
);

export const getFeesByYearUpdate = createSelector(
  createPhasesUpdate,
  createAdditionalsUpdate,
  createFeesUpdate,
  (phases, additionals, fees) => {
    const y1 = phases.reduce((sum, x) => {
      if (x.phase.indexOf("Surveillance") < 0) {
        return sum + x.day * x.rate;
      }
      return sum;
    }, 0);

    const nextYears = phases.reduce((sum, x) => {
      if (x.phase.indexOf("Surveillance") === 0) {
        return [
          ...sum,
          {
            ...x,
            amount: x.day * x.rate,
          },
        ];
      }
      return sum;
    }, []);

    const allFees = fees.reduce((x, y) => {
      return x + y.quantity * y.rate;
    }, 0);

    const result = [
      {
        phase: "First Year",
        description: "CA1 + CA2 + Other fees",
        amount: y1 + allFees,
      },
      ...nextYears,
    ];

    return result;
  }
);

const scopesSelector = (state) =>
  state.quotations.quotation.data
    ? state.quotations.quotation.data.questionnaire.scopes
    : [];

export const needBODSelector = createSelector(scopesSelector, (items) =>
  items.reduce((x, y) => {
    if (x === true) {
      return true;
    } else {
      if (y.standard.detail.bod_approval) {
        return true;
      } else {
        return false;
      }
    }
  }, false)
);

export function filterAuditCycle(cycles) {
  const surveillance = cycles.filter(
    (x) => x.phase.indexOf("Follow-up Audit / Special Audit") === -1
  );
  const finalCycles = [...surveillance];

  return finalCycles;
}

export function breakdownAuditCycle(cycles) {
  const stage1 = cycles.find(
    (x) => x.phase === "Certification Audit Stage 1" && x.include
  );
  const stage2 = cycles.find(
    (x) => x.phase === "Certification Audit Stage 2" && x.include
  );
  const surveillance = cycles
    .filter((x) => x.phase.indexOf("Certification Audit") === -1)
    .map((x) => ({ ...x, subtotal: x.rate * x.day, part: x.phase }));

  // Stage 1 & Stage 2 are shown as separate rows for clarity, but the backend
  // only recognizes `part=Certification Audit` for the sub-quotation PDF, so
  // both rows point to that part.
  const certification = [];
  if (stage1) {
    certification.push({
      ...stage1,
      subtotal: stage1.rate * stage1.day,
      part: "Certification Audit",
    });
  }
  if (stage2) {
    certification.push({
      ...stage2,
      subtotal: stage2.rate * stage2.day,
      part: "Certification Audit",
    });
  }

  return [...certification, ...surveillance];
}
